module.exports = __webpack_public_path__ + "img/u.035c5260.svg";